import { useEffect } from "react";

import { useCurrentConversation } from "@/lib/hooks/conversations/use-current-conversation";
import { useHubStore, type HubView } from "./use-hub-store";

const PENDING_ENTITY_VIEW: Record<string, HubView> = {
  NOTE: "view-note",
  MOMENT: "view-moment",
  SWAP: "view-swap",
};

interface PendingHubEntityHandlerProps {
  channelUrl: string;
}

export function PendingHubEntityHandler({
  channelUrl,
}: PendingHubEntityHandlerProps) {
  const pendingEntity = useCurrentConversation((state) => state.pendingEntity);
  const setPendingEntity = useCurrentConversation(
    (state) => state.setPendingEntity,
  );
  const openToView = useHubStore((state) => state.openToView);

  useEffect(() => {
    if (!pendingEntity) return;
    if (pendingEntity.channel && pendingEntity.channel !== channelUrl) return;

    const view = PENDING_ENTITY_VIEW[pendingEntity.type];
    if (view) {
      openToView(view, pendingEntity.id);
    }
    setPendingEntity(null);
  }, [pendingEntity, channelUrl, openToView, setPendingEntity]);

  return null;
}
